import React from 'react'
import { IS_ITEST_UI } from '../config/api'

/**
 * Indicador visible solo en builds con VITE_API_MODE=same-origin|itest.
 * Distingue la UI de laboratorio del frontend habitual (9191 / producción).
 */
export default function ItestEnvironmentBanner() {
  if (!IS_ITEST_UI) return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10000,
        width: '100%',
        boxSizing: 'border-box',
        padding: '6px 12px',
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
        fontSize: '13px',
        fontWeight: 600,
        letterSpacing: '0.02em',
        color: '#1a1a1a',
        background: 'linear-gradient(90deg, #f5c542 0%, #e8b923 50%, #f5c542 100%)',
        borderBottom: '1px solid #c9a018',
      }}
    >
      PDFSigner V2 — ENTORNO DE PRUEBAS
    </div>
  )
}
